import I18n from 'i18n-js';
import React from 'react';

import UrlHelpers from '../shared/url_helpers';
import CombinedShippingRateExamples from './combined_shipping_rate_examples';

import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import FormGroupWithCheckbox from '@reverbdotcom/commons/src/components/form_group_with_checkbox';
import AlertBox from '@reverbdotcom/commons/src/components/alert_box';

interface IProps {
  allowedToShipExpedited: boolean;
  isExpeditedShippingEnabled: boolean;
  allowedToShipCombined: boolean;
  isCombinedShippingEnabled: boolean;
  handleExpeditedShippingToggle: Function;
  handleCombinedShippingToggle: Function;
  currency: string;
}

function RateOptionsToggles(props: IProps) {
  return (
    <>
      {/* Expedited shipping toggle */}
      <FormGroupWithCheckbox
        inputName="shipping_profile[offers_expedited_shipping]"
        label={I18n.t('discovery.dashboard.selling.shippingRates.toggles.expeditedShipping.enable')}
        updateField={props.handleExpeditedShippingToggle}
        checked={props.isExpeditedShippingEnabled}
        disabled={!props.allowedToShipExpedited}
        helpText={(
          <>
            {I18n.t('discovery.dashboard.selling.shippingRates.toggles.expeditedShipping.explainer')}
            {!props.allowedToShipExpedited && (
              <CoreLink
                to={UrlHelpers.expeditedShippingHelpPath}
                target="_blank"
                className="ml-space"
              >
                {I18n.t('discovery.dashboard.selling.shippingRates.toggles.expeditedShipping.learnToQualify')}
              </CoreLink>
            )}
          </>
        )}
      >
        {props.isExpeditedShippingEnabled && (
          <div className="scaling-mt-1">
            <AlertBox type="info" small>
              <p className="lh-120 mb-0">
                {I18n.t('discovery.dashboard.selling.shippingRates.toggles.expeditedShipping.finePrint')}
                <CoreLink
                  to={UrlHelpers.expeditedShippingHelpPath}
                  target="_blank"
                  className="ml-space"
                >
                  {I18n.t('discovery.dashboard.selling.shippingRates.toggles.learnMore')}
                </CoreLink>
              </p>
            </AlertBox>
          </div>
        )}
      </FormGroupWithCheckbox>

      {/* Combined shipping toggle */}
      {props.allowedToShipCombined && (
        <div className="scaling-mt-3">
          <FormGroupWithCheckbox
            inputName="shipping_profile[offers_combined_shipping]"
            label={I18n.t('discovery.dashboard.selling.shippingRates.toggles.combinedShipping.enable')}
            updateField={props.handleCombinedShippingToggle}
            checked={props.isCombinedShippingEnabled}
            helpText={(
              <>
                {I18n.t('discovery.dashboard.selling.shippingRates.toggles.combinedShipping.explainer')}
                <CoreLink
                  to={UrlHelpers.combinedShippingGuidePath}
                  target="_blank"
                  className="ml-space"
                >
                  {I18n.t('discovery.dashboard.selling.shippingRates.toggles.learnMore')}
                </CoreLink>
              </>
            )}
          />
          {props.isCombinedShippingEnabled && (
            <div className="scaling-mt-2">
              <CombinedShippingRateExamples currency={props.currency} />
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default RateOptionsToggles;
